import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { doTrackedRedirect } from "../../lib/track";
import MobileCaptureDialog from "../MobileCaptureDialog";
import CreditSeaSmartDialog from "../CreditSeaSmartDialog";
import { sortByRate } from "../../lib/loanStats";

const Ctx = createContext(null);
export const useLoans = () => useContext(Ctx);

export const isCreditSeaSmart = (p) =>
  (p?.provider || "").replace(/\s+/g, "").toLowerCase() === "creditseasmart";

export function LoansProvider({ children }) {
  const [products, setProducts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [capture, setCapture] = useState(null);
  const [smart, setSmart] = useState(null);

  useEffect(() => {
    api.get("/products", { params: { type: "banking", channel: "loans_only" } })
      .then((r) => setProducts(sortByRate(r.data || [])))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  const apply = (p) => {
    if (!p) return;
    if (isCreditSeaSmart(p)) setSmart(p);
    else setCapture(p);
  };

  return (
    <Ctx.Provider value={{ products, loaded, apply }}>
      {children}
      <MobileCaptureDialog
        open={!!capture}
        onOpenChange={(v) => { if (!v) setCapture(null); }}
        product={capture}
        onCaptured={async () => {
          if (capture) await doTrackedRedirect(capture);
          setCapture(null);
        }}
      />
      <CreditSeaSmartDialog
        open={!!smart}
        onOpenChange={(v) => { if (!v) setSmart(null); }}
        product={smart}
        metaPixelId={smart?.meta_pixel_id}
      />
    </Ctx.Provider>
  );
}
